export default class Cart {
  constructor(buttons) {

    if (!buttons) {
      return;
    }

    this.buttons = buttons;
    this.removeButtons = [...document.getElementsByClassName('remove')];

    this.clickEventsAmount();
  }

  clickEventsAmount() {
    Object.keys(this.buttons).forEach((button) => {
      const el = this.buttons[button];
      el.addEventListener('click', (event) => {
        event.preventDefault();

        const dataTarget = el.dataset.target;

        if( !dataTarget ) {
          return;
        }

        const target = document.querySelector('[name="' + dataTarget + '"]');
        if (!target) {
          return;
        }

        const newValue = parseInt(target.value) + parseInt(el.dataset.dir);

        if( target.min && parseInt(target.min) >= newValue) {
          el.parentNode.parentNode.querySelector('.remove').click();
          document.querySelector('[name="update_cart"]').click();
        }

        target.value = newValue.toString();
        document.querySelector("button[name='update_cart']").disabled = false;
      });
    });
  }
}

